import { render, staticRenderFns } from "./OrderFormPoint.vue?vue&type=template&id=a3e844fc&scoped=true&"
import script from "./OrderFormPoint.vue?vue&type=script&lang=js&"
export * from "./OrderFormPoint.vue?vue&type=script&lang=js&"
import style0 from "./OrderFormPoint.vue?vue&type=style&index=0&id=a3e844fc&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3e844fc",
  null
  
)

export default component.exports